import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  actionCell: {
    width: theme.size.base,
    textAlign: 'center'
  },

  deleteIconDisabled: {
    color: '#E4E8EA',
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },

  deleteIcon: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}))

export default useStyles
